import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFuelTypeList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditFuelTypeModal from './Add_Edit/AddEditFuelTypeModal';
import DeleteFuelTypeModal from './Delete/DeleteFuelType';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const FuelTypeList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFuelType = createSelector(
		state => state.FuelType,
		fuelType => ({
			fuelTypeList: fuelType.fuelTypeList,
			isLoadingList: fuelType.isLoadingList,
			isFuelTypeSuccess: fuelType.isFuelTypeSuccess,
			error: fuelType.error,
			isAdding: fuelType.isAdding,
			isAdded: fuelType.isAdded,
			isAddError: fuelType.isAddError,
			isUpdating: fuelType.isUpdating,
			isUpdated: fuelType.isUpdated,
			isUpdateError: fuelType.isUpdateError,
			isDeleting: fuelType.isDeleting,
			isDeleted: fuelType.isDeleted,
			isDeleteError: fuelType.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { fuelTypeList, isLoadingList } = useSelector(selectorFuelType);

	useEffect(() => {
		dispatch(getFuelTypeList());
	}, []);

	const [dataFuelType, setDataFuelType] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete FuelType
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = fuelType => {
		setDataFuelType(fuelType);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = fuelType => {
		setDataFuelType(fuelType);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'fuelType',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const fuelTypeData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(fuelTypeData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const fuelTypeData =
														cellProps.row.original;
													handleClickDelete(fuelTypeData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto', },
			{ header: 'Código', accessorKey: 'code', size: 'auto', },
			{ header: 'Factor de Emisión', accessorKey: 'emission_factor', size: 'auto', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataFuelType({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Tipo de Combustible
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={fuelTypeList || []}
								isLoadingData={isLoadingList}
								nameFile={'tipo_combustible'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataFuelType({});
											handleToggleModal();
										},
										title: 'Crear Tipo de Combustible'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFuelTypeModal
				dataFuelType={dataFuelType}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteFuelTypeModal
				dataFuelType={dataFuelType}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FuelTypeList;
